import { Component, Inject, HostListener, ElementRef, Input } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {FiltersService} from './filters.service';
import {ViewService} from '../shared/view.service';
import {Utils} from '../utils';

@Component({
    selector: 'save-view',
    templateUrl: 'save-view.component.html'
})
export class SaveViewComponent {
    panelOpen = false;
    @HostListener('document:click', ['$event'])
    maybeClosePane(e) {
        if( !this.el.nativeElement.contains(e.target) ) {
            this.panelOpen = false;
        }
    }
    constructor(private el: ElementRef, public dialog: MatDialog, public vs: ViewService, private fs: FiltersService) { }
    openViewSettings(saveCurrentView) {
        if( saveCurrentView && this.vs.currentView) {
            this.vs.updateCurrentView(this.fs.columns, this.fs.filters, this.fs.query.relation);
        } else {
            this.panelOpen = false;
            let dialog = this.dialog.open(SaveViewDialog, {
                data: {
                    title: '',
                    icon: '',
                }
            });
            dialog.afterClosed().subscribe(data => {
                if( data ) {
                    data.filters = this.fs.filters;
                    data.relation = this.fs.query.relation;
                    data.columns = this.fs.columns;
                    this.vs.addView(data);
                }                
            });
        }
    }
    togglePanel() {
        this.panelOpen = !this.panelOpen;
    }
}
@Component({
    selector: 'save-view-dialog',
    template: `
        <h2 mat-dialog-title>Save View</h2>
        <mat-dialog-content id="save-view-dialog">
            <mat-form-field>
                <input matInput [(ngModel)]="data.title" placeholder="View Name" maxlength="25" name="saveViewTitle" autocomplete="saveViewTitle" id="saveViewTitle{{saveViewTitle}}"/>
            </mat-form-field>
            <div id="icon-options">
                <mat-icon class="mat-gray" *ngFor="let icon of icons" (click)="selectIcon(icon)" [ngClass]="{selected: icon == data.icon}">{{icon}}</mat-icon>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="mat-flat-button mat-unassigned" [mat-dialog-close]="data">Save</button>
        </mat-dialog-actions>`,
})
export class SaveViewDialog {
    saveViewTitle = this.utils.rand();
    icons = [
        'accessibility_new',
        'account_box',
        'account_circle',
        'account_balance',
        'alarm',
        'all_inbox',
        'assessment',
        'assignment',
        'assignment_ind',
        'assignment_late',
        'assignment_turned_in',
        'autorenew',
        'book',
        'bookmark',
        'bookmark_border',
        'bookmarks',
        'bug_report',
        'build',
        'calendar_today',
        'calendar_view_day',
        'dashboard',
        'date_range',
        'description',
        'done',
        'done_all',
        'donut_large',
        'drag_indicator',
        'event',
        'exit_to_app',
        'extension',
        'face',
        'favorite',
        'fingerprint',
        'flip_to_back',
        'flip_to_front',
        'get_app',
        'grade',
        'group_work',
        'help',
        'home',
        'horizontal_split',
        'hourglass_full',
        'hourglass_empty',
        'label',
        'label_important',
        'language',
        'launch',
        'line_style',
        'list',
        'loyalty',
        'markunread_mailbox',
        'offline_bolt',
        'pan_tool',
        'pets',
        'settings',
        'star_rate',
        'stars',
        'subject',
        'thumb_up',
        'timeline',
        'toc',
        'trending_down',
        'trending_flat',
        'trending_up',
        'view_module',
        'work',
        'sentiment_satisfied_alt',
        'create',
        'clear',
        'filter_list',
        'flag',
        'outlined_flag',
        'forward',
        'gesture',
        'inbox',
        'reply',
        'reply_all',
        'send',
        'waves',
        'weekend',
        'attach_file',
        'attach_money',
        'border_all',
        'border_color',
        'bubble_chart',
        'insert_emoticon',
        'scatter_plot',
        'show_chart',
        'space_bar',
        'trip_origin',
        'apps',
        'adb',
        'more',
        'child_care',
        'casino',
        'fitness_center',
        'golf_course',
        'hot_tub',
        'spa',
        'cake',
        'mood',
        'mood_bad',
        'notifications',
        'pages',
        'whatshot'
    ]
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private utils: Utils) {}
    selectIcon(icon) {
        this.data.icon = icon;
    }
}